exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".bind-supplier .buttons[data-v-f859974a]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}.bind-supplier .upload-excel[data-v-f859974a]  .drop{margin:0}", ""]);

// exports
